<template>
  <div class="container-fluid mt-3">
    <section>
      <div class="row">
        <div class="col">
          <h4 class="form-head">Debug Tracking API</h4>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-3">
          <div class="form-group">
            <label for="Transporter">Transporter</label>
            <select name="transporter" id="Transporter" class="form-control" v-model="transporter">
              <option v-for="t of transporters" :key="t.id" :value="t.gstin">{{t.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="Transporter">Location</label>
            <select name="Location" id="Location" class="form-control" v-model="location" @change="locationChanged">
              <option v-for="t of locations" :key="t.id" :value="t.id">{{t.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="Transporter">Location Code</label>
            <select name="Location" id="LocationCode" class="form-control" v-model="locationCode">
              <option v-for="t of locationCodes" :key="t" :value="t">{{t}}</option>
            </select>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="LRNO">LR No</label>
            <input type="text" class="form-control" name="LRNO" id="LRNO" v-model="lrNo">
          </div>
        </div>
        <div class="col-3">
          <div class="form-group mt-4">
            <label for="">&nbsp;</label>
            <button class="btn btn-success" @click="getTracking">Track</button>
          </div>
        </div>
      </div>
      <div class="row" v-if="tracking.deliveryStatus">
        <div class="col">
          <table class="table">
            <thead>
            <tr>
              <th colspan="3">
                Tracking details for {{lrNo}}
              </th>
            </tr>
            <tr>
              <th>Status</th>
              <th>Pickup</th>
              <th>Promise</th>
              <th>Weight</th>
              <th>POD URL</th>
              <th>History</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{tracking.deliveryStatus}}</td>
              <td>{{tracking.pickupDate}}</td>
              <td>{{tracking.promiseDate}}</td>
              <td>{{tracking.weight}}</td>
              <td>
                <a :href="tracking.podUrl" target="_blank" v-if="tracking.deliveryStatus === 'DELIVERED'">{{tracking.podUrl}}</a>
              </td>
              <td>
                <ul>
                  <li v-for="l of tracking.docketHistory" :key="l">{{l.location}} -- {{l.date}} -- {{l.deliveryStatus}}</li>
                </ul>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <section>
      <div class="row">
        <div class="col-3">
          <div class="form-group">
            <label for="">User Name</label>
            <input v-model="userName" type="text" class="form-control"/>
          </div>
          <button class="btn btn-sm btn-info" @click="getDivisions()">
            Get Divisions
          </button>
        </div>
        <div class="col-7">
          <p>Divisions for {{userName}}</p>
          <ul>
            <li v-for="d in userDivisions" :key="d.division">{{d.group}} -- {{d.division}}</li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from 'axios'
let apiUrl = `https://app.e-waybill.in/jobs/track-detail`
let apiUrlTransporter = `/app/party?type=TRANSPORTER`
let apiUrlLocation = `/app/location?admin=true`
export default {
  name: 'DistancePage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (!this.$store.state.loggedIn) {
        console.log('Not Logged-in')
        this.$router.push('login')
      }
      this.loadCreds()
    })
  },
  data () {
    return {
      transporters: [],
      locations: [],
      lrNo: '',
      transporter: '',
      location: '',
      locationCode: '',
      locationCodes: [],
      tracking: {},
      userName: '',
      userDivisions: []
    }
  },
  methods: {
    getDivisions: function () {
      axios.get(`/misc/user-divisions?user_name=${this.userName}`)
        .then(resp => {
          this.userDivisions = resp.data
        })
    },
    loadCreds: function () {
      axios.get(apiUrlTransporter)
        .then(response => {
          this.transporters = response.data
        }, error => {
          console.error('Error in Loading Creds', error)
        })
      axios.get(apiUrlLocation)
        .then(response => {
          this.locations = response.data
        }, error => {
          console.error('Error in Loading Creds', error)
        })
    },
    locationChanged: function () {
      this.locationCode = ''
      this.locationCodes = this.locations.filter(f => f.id === this.location)[0].codes
    },
    getTracking: function () {
      this.tracking = {}
      if (this.transporter.length !== 15) {
        this.$bvToast.toast(`This Transporter is not supported`, {
          title: 'Unsupported Transporter',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      if (this.locationCode.length === 0) {
        this.$bvToast.toast(`Select Location?`, {
          title: 'Location Code Not Selected?',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      axios.get(`${apiUrl}?transporter=${this.transporter}&tracking=${this.lrNo}&location=${this.locationCode}`)
        .then(response => {
          this.tracking = response.data
        }, error => {
          if (error.response.status === 400) {
            this.$bvToast.toast(`This Transporter is not supported`, {
              title: 'Unsupported Transporter',
              autoHideDelay: 5000,
              variant: 'warning',
              appendToast: true
            })
          }
          if (error.response.status === 500) {
            this.$bvToast.toast(`Error in Searching`, {
              title: 'Error In Searching Details',
              autoHideDelay: 5000,
              variant: 'danger',
              appendToast: true
            })
          }
          console.error('error in saving cred', error)
        })
    },
    editPin: function (cred) {
      this.c = cred
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/admin/Debug.vue